
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm0 1.2A7.79 7.79 0 0 1 16.8 9 7.79 7.79 0 0 1 9 16.8 7.79 7.79 0 0 1 1.2 9 7.79 7.79 0 0 1 9 1.2zm-.406 2.187A.604.604 0 0 0 8 4v5.4a.6.6 0 0 0 .6.6H14a.6.6 0 1 0 0-1.2H9.2V4a.601.601 0 0 0-.606-.613z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\">\r\n            <g>\r\n                <path d=\"M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm0 1.2c4.315 0 7.8 3.485 7.8 7.8 0 4.315-3.485 7.8-7.8 7.8-4.315 0-7.8-3.485-7.8-7.8 0-4.315 3.485-7.8 7.8-7.8zm-.406 2.187c-.16.002-.313.068-.425.183-.111.115-.172.27-.169.43v5.4c0 .331.269.6.6.6H14c.216.003.418-.11.527-.298.109-.186.109-.418 0-.604-.11-.187-.31-.301-.527-.298H9.2V4c.003-.162-.06-.32-.173-.435-.115-.115-.27-.18-.433-.178z\" transform=\"translate(-324 -436) translate(324 436)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/time.e69c06075ad3af9cd78d621592b42207.svg"),
        {
          React: SvgTime,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      